import $ from 'jquery'
$(document).ready(function() {
	$('.accordion-title').on('click', function() {
		$(this)
			.parent()
			.toggleClass('is-active')
	})
})
